import { px } from "../../utils";
import { CHECKBOX_BORDER_WIDTH, WHCM_DISABLED_ITEM_COLOR, WHCM_ITEM_COLOR } from "../constants";
export var windowsHighContrastDisableStyle = function windowsHighContrastDisableStyle() {
  return {
    '.detailedCheckboxTick': {
      backgroundColor: WHCM_DISABLED_ITEM_COLOR,
      borderColor: WHCM_DISABLED_ITEM_COLOR
    },
    border: "solid ".concat(px(CHECKBOX_BORDER_WIDTH), " ").concat(WHCM_DISABLED_ITEM_COLOR),
    'input:checked ~ &': {
      '.tick': {
        stroke: WHCM_ITEM_COLOR,
        strokeDasharray: '15, 20000',
        opacity: 1
      }
    }
  };
};
export var windowsHighContrastTickStyle = function windowsHighContrastTickStyle() {
  return {
    '.detailedCheckboxTick': {
      '.tick': {
        stroke: WHCM_ITEM_COLOR,
        strokeDasharray: '15, 20000',
        opacity: 1
      }
    }
  };
};